/**
 * NOTE: This code belongs to Kangaroo Rewards. Unauthorized use is prohibited
 */

@file:Suppress("unused", "MemberVisibilityCanBePrivate", "EXPERIMENTAL_API_USAGE")

package features.publicReward.internal

import features.publicReward.models.PublicRewardResponseModel
import kangaroorewards.appsdk.core.io.IOResult
import kangaroorewards.appsdk.core.network.NetworkRequest
import kangaroorewards.appsdk.core.network.base.PathParameter
import kangaroorewards.appsdk.core.network.base.replaceInPath

internal class PublicRewardRequest : NetworkRequest() {

    suspend fun getPublicReward(
        overrideHeaders: Map<String, String>? = null,
        rewardSlug: String
    ): IOResult<PublicRewardResponseModel> {
        return safeNetworkCall {
            get(
                endpoint = PublicRewardEndpoint.replaceInPath(
                    PathParameter("rewardSlug", rewardSlug),
                ),
                serverHostId = 0,
                overrideHeaders = overrideHeaders
            )
        }
    }
}
